import axios from 'axios';

const BASE = '/api/intelligence';

export const intelligenceApi = {
  // Phase 1 — Contact Profiles
  getContacts: (params = {}) =>
    axios.get(`${BASE}/contacts`, { params }).then((r) => r.data),

  getContact: (contactId) =>
    axios.get(`${BASE}/contacts/${contactId}`).then((r) => r.data),

  // Phase 2 — Weekly Plan
  getWeeklyPlan: () =>
    axios.get(`${BASE}/weekly-plan`).then((r) => r.data),

  approveAudience: (id) =>
    axios.post(`${BASE}/audiences/${id}/approve`).then((r) => r.data),

  // Approve audience + generate AI content synchronously — returns suggestion + recommendation
  generatePreview: (id) =>
    axios.post(`${BASE}/audiences/${id}/generate-preview`).then((r) => r.data),

  rejectAudience: (id) =>
    axios.post(`${BASE}/audiences/${id}/reject`).then((r) => r.data),

  approveRecommendation: (id) =>
    axios.post(`${BASE}/recommendations/${id}/approve`).then((r) => r.data),

  rejectRecommendation: (id) =>
    axios.post(`${BASE}/recommendations/${id}/reject`).then((r) => r.data),

  // scheduleAt: ISO string, subject/bodyHtml: optional edits, personalisationMode: 'none'|'ai_generated'
  // personalisedOverrides: [{ email, body_html }] — user-edited per-contact HTML (optional)
  convertRecommendation: (id, scheduleAt, subject, bodyHtml, personalisationMode = 'none', personalisedOverrides = null) =>
    axios.post(`${BASE}/recommendations/${id}/convert`, {
      schedule_at: scheduleAt,
      personalisation_mode: personalisationMode,
      ...(subject  ? { subject }   : {}),
      ...(bodyHtml ? { body_html: bodyHtml } : {}),
      ...(personalisedOverrides?.length ? { personalised_overrides: personalisedOverrides } : {}),
    }).then((r) => r.data),

  getAudienceSignals: (id) =>
    axios.get(`${BASE}/audiences/${id}/signals`).then((r) => r.data),

  runDiscovery: () =>
    axios.post(`${BASE}/discovery/run`).then((r) => r.data),

  clearPlan: () =>
    axios.delete(`${BASE}/plan/clear`).then((r) => r.data),

  previewPersonalised: (payload) =>
    axios.post(`${BASE}/personalisation/preview`, payload).then((r) => r.data),

  getInsights: () =>
    axios.get(`${BASE}/insights`).then((r) => r.data),

  getSalesFunnels: (params = {}) =>
    axios.get(`${BASE}/sales-funnels`, { params }).then((r) => r.data),

  // Phase 5 — Sales Intelligence
  getSalesDashboard: (days = 30) =>
    axios.get(`${BASE}/sales-intelligence`, { params: { days } }).then((r) => r.data),

  getSalesFunnel: (days = 30) =>
    axios.get(`${BASE}/sales-intelligence/funnel`, { params: { days } }).then((r) => r.data),

  getSalesTeam: (days = 30) =>
    axios.get(`${BASE}/sales-intelligence/team`, { params: { days } }).then((r) => r.data),

  getSalesAtRisk: () =>
    axios.get(`${BASE}/sales-intelligence/at-risk`).then((r) => r.data),

  getSalesTriggers: () =>
    axios.get(`${BASE}/sales-intelligence/triggers`).then((r) => r.data),

  executeSalesTrigger: (id) =>
    axios.post(`${BASE}/sales-intelligence/triggers/${id}/execute`).then((r) => r.data),

  dismissSalesTrigger: (id) =>
    axios.post(`${BASE}/sales-intelligence/triggers/${id}/dismiss`).then((r) => r.data),

  // Phase 7 — Weekly Content Automation (Travel Tips + Promotions)
  getWeeklyContent: () =>
    axios.get(`${BASE}/weekly-content`).then((r) => r.data),

  getWeeklyContentEngagement: () =>
    axios.get(`${BASE}/weekly-content/engagement`).then((r) => r.data),

  approveWeeklyContent: (id) =>
    axios.post(`${BASE}/weekly-content/${id}/approve`).then((r) => r.data),

  rejectWeeklyContent: (id) =>
    axios.post(`${BASE}/weekly-content/${id}/reject`).then((r) => r.data),

  // scheduleAt: ISO string; subject/bodyHtml: optional overrides before converting
  convertWeeklyContent: (id, scheduleAt, subject = null, bodyHtml = null) =>
    axios.post(`${BASE}/weekly-content/${id}/convert`, {
      schedule_at: scheduleAt,
      ...(subject  ? { subject }            : {}),
      ...(bodyHtml ? { body_html: bodyHtml } : {}),
    }).then((r) => r.data),
};
